import { render, staticRenderFns } from "./InquirySetup.vue?vue&type=template&id=4fa74d5d&scoped=true&"
import script from "./InquirySetup.vue?vue&type=script&lang=js&"
export * from "./InquirySetup.vue?vue&type=script&lang=js&"
import style0 from "./InquirySetup.vue?vue&type=style&index=0&id=4fa74d5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa74d5d",
  null
  
)

export default component.exports